import * as _ from 'underscore';
export default class Press {
    constructor() {
        console.log('%c👍🏼 Press', 'color: yellow');
        
        this.press = document.querySelector('.press-module')
        this.pressList = this.press.querySelector('.press-list')
        this.pressListResults = this.press.querySelector('.press-list__results')
        this.tags = []
        this.search = ""
        this.pressTemplate = this.press.querySelector('.pressTemplate');
        this.pressData;
        this.overlay = this.press.querySelector('.overlay');
        this.loadMore = this.press.querySelector('button');
        this.paged = 1;
    }

    init() { 
        this.loadMore.addEventListener( 'click', async event => {
            this.paged++;
            this.showOverlay();
            await this.loadPress();
            this.hideOverlay();
            this.filterPress();
        })
    }

    showOverlay() {
        this.overlay.style.display= 'flex';
    }

    hideOverlay() {
        this.overlay.style.display= 'none';
    }

   async loadPress() {
        const apiString = this.getAPIString();
        const dataResponse = await fetch(apiString);
        console.log(dataResponse);
        this.pressData = await dataResponse.json();
    }

    async filterPress() {
        this.loadMore.parentElement.style.display= 'none';
        console.log('this.pressData', this.pressData);
        if(this.pressData.press.length) {
            this.pressData.press.forEach( press => {
                this.templatePress(press);      
            })
        } 
        console.log(this.pressData.numPosts,  this.paged * 9)
        if(this.pressData.numPosts > this.paged * 9) {
            this.loadMore.parentElement.style.display = 'block';
        }
    }

    getAPIString() {
        let string = this.press.getAttribute('data-json');
        string = string + '?paged=' + this.paged;
        return string;
    }

    templatePress(press) {
        let template = _.template(this.pressTemplate.innerHTML);
        let compiledResult = template(press);
        this.pressListResults.insertAdjacentHTML( 'beforeend', compiledResult );
    }
}